import { render } from "./ReportedWebsites2.vue?vue&type=template&id=01094bb9&scoped=true"
import script from "./ReportedWebsites2.vue?vue&type=script&lang=js"
export * from "./ReportedWebsites2.vue?vue&type=script&lang=js"

import "./ReportedWebsites2.vue?vue&type=style&index=0&id=01094bb9&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01094bb9"]])

export default __exports__